import { render } from "./request-password-reset-component.vue?vue&type=template&id=7b8b4044"
import script from "./request-password-reset-component.vue?vue&type=script&lang=js"
export * from "./request-password-reset-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__